<template>
  <div>
    <div v-if="isLoading"></div>
    <template else>
      <Navbar :authenticated="authFlag" />
      <!-- Polly header -->
      <PollyHeader :polly="polly" :altText="altHeaderText" />

      <!-- Main polly -->
      <section>
        <div class="container">
          <div class="row">
            <!-- Polly posts -->
            <div class="col-12 col-md-8">
              <div v-if="article" class="post">
                <h3 class="post__title mb-0">{{article.title}}</h3>
                <div class="post__meta d-flex align-items-center">
                  <span>{{article.profile.name}}, {{article.created | happroxy(true)}}</span>
                </div>
                <div class="post__body mt-4">
                  <p v-html="article.first_media.body"></p>
                </div>

                <div v-if="article.first_media.media_uploads.length > 0" class="content-media mb-3">
                  <div
                    class="card-columns photo-grid"
                    :style="`column-count:${calculateColumns(article.first_media.media_uploads)}`"
                  >
                    <div class="photo-grid__photo">
                      <img
                        v-for="img in article.first_media.media_uploads"
                        :key="img._id"
                        class="img-fluid"
                        v-lazy="img.upload.path"
                        @click="showImage(img.upload.path, article.first_media._id)"
                      />
                      <lightbox
                        :id="'lightbox' + article.first_media._id"
                        ref="lightbox"
                        :images="getImagesForLightBox(article.first_media.media_uploads)"
                      ></lightbox>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-start w-100">
                  <button
                    @click="share()"
                    style="background-color: #14264d"
                    class="btn btn-md text-white my-1 mr-2"
                  >
                    <ion-icon name="ios-share-alt"></ion-icon>Share this
                  </button>

                  <input
                    id="share-input"
                    v-if="shareVisible"
                    class="form-control"
                    readonly
                    :value="articleLink ? articleLink : 'Processing...'"
                  />
                </div>
              </div>
            </div>

            <!-- Ad section -->
            <div class="col-12 col-md-4 sticky-top mt-5 mt-md-0" style="top:70px">
              <AdMenu />
            </div>
          </div>
        </div>
      </section>
      
      <LoginModal :auth="auth" />
      <InviteModal :auth="auth" />
      <ResetModal :auth="auth" />
      <SignupModal :auth="auth" />

    </template>
  </div>
</template>

<script>
import Navbar from "@/components/Landing/Nav/Nav.vue";
import AdMenu from "@/components/Main/AdMenu/AdMenu.vue";
import PollyHeader from "@/components/Main/Polly/PollyHeader.vue";
import DataHandlerService from "@/services/data";
import ContentService from "@/services/content";
import CircleService from "@/services/circle";
import router from '../../router';

import LoginModal from "@/components/Auth/LoginModal/LoginModal.vue";
import InviteModal from "@/components/Auth/InviteModal/InviteModal.vue";
import ResetModal from "@/components/Auth/ResetModal/ResetModal.vue";
import SignupModal from "@/components/Auth/SignupModal/SignupModal.vue";

const shortUrl = require("node-url-shortener");

const dataService = new DataHandlerService();
const contentService = new ContentService();
const circleService = new CircleService();

export default {
  name: "PollyPost",
  props: ["auth", "authenticated"],
  components: {
    Navbar,
    AdMenu,
    PollyHeader,

    LoginModal,
    InviteModal,
    ResetModal,
    SignupModal,
  },
  data() {
    return {
      authFlag: this.$props.authenticated,
      polly: null,
      article: null,
      shareVisible: false,
      articleLink: null,
      isLoading: true,
      altHeaderText: null,
      user: null,
    };
  },
  created() {
    this.user = dataService.getUserData()
    const topic_id = this.$route.params.id;
    this.initialize()
  },
  methods: {
    initialize () {
      
      let { vanity_url, id } = this.$route.params
      this.isLoading = true
      circleService.readCircleVanityByIdentity(vanity_url).then(res => {
        // log response
        if(res && res.type === 'circle-polly-out') {
          const circle_id = res.parent_id
          // this.vanity = res
          contentService
            .readSingleTopic(id)
            .then(topic => {
              circleService
                .getCirclePolly(vanity_url, 1, 0)
                .then(data => {
                  this.isLoading = false
                  this.polly = data.circle;
                  this.article = topic;
                  this.altHeaderText = topic.title
                })
                .catch(err => {
                  err && err.message
                    ? this.$root.$emit("ShowErrorNotification", err.message)
                    : this.$root.$emit(
                        "ShowErrorNotification",
                        "An error occurred. Please try again."
                      );
                });
            })
            .catch(err => {
              router.replace(`/v/${vanity_url}`)
              err && err.message
                ? this.$root.$emit("ShowErrorNotification", 'Post not found!') // err.message)
                : this.$root.$emit(
                    "ShowErrorNotification",
                    "An error occurred. Please try again."
                  );
            });

        } else {
          router.replace('/404')
        }
      }).catch(err => {
        // log error
        this.isLoading = false
        this.error = err
      })
    },
    share() {
      this.shareVisible = !this.shareVisible;

      if (!this.articleLink) {
        if (window.location.host.includes("localhost")) {
          this.articleLink = window.location.href;
        } else {
          shortUrl.short(window.location.href, (err, url) => {
            if (url) {
              this.articleLink = url;
            } else {
              this.articleLink = window.location.href;
            }
          });
        }
      }
    },
    calculateColumns(photos) {
      if (photos.length === 1) return 1;
      else if (photos.length > 1 && photos.length < 5) return 2;
      else return 3;
    },
    showImage(name, doc_id) {
      if (Array.isArray(this.$refs.lightbox)) {
        const lightbox = this.$refs.lightbox.find(
          s => s.$el.id === `lightbox${doc_id}`
        );
        if (lightbox) {
          lightbox.show(name);
        }
      } else {
        this.$refs.lightbox.show(name);
      }
    },
    getImagesForLightBox(data) {
      const images = [];
      const pollyImages = data;

      pollyImages.forEach(img => {
        images.push({ name: img.upload.path, id: img._id });
      });

      return images;
    }
  }
};
</script>

<style lang="scss" scoped>
.post {
  &__meta {
    color: #919eab;
    font-size: 13px;
  }
}
</style>